import GoodsList from './goodsList.vue'
import ServerList from './serverList.vue'

export {
    GoodsList,
    ServerList
}
